function Footer() {
  return (
    <div className='text-center leading-[19px] text-gray-500'>
      Copyright © {new Date().getFullYear()} AvoMD. All rights reserved.
    </div>
  );
}

export default Footer;
